import { Button, Grid, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Image from 'mui-image';
import { useEffect, useState } from 'react';
import { useSpring, animated, useTrail } from "react-spring";
import Project from './Project';
import IconButton from '@material-ui/core/IconButton';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowCircleLeftRoundedIcon from '@mui/icons-material/ArrowCircleLeftRounded';
import ArrowCircleRightRoundedIcon from '@mui/icons-material/ArrowCircleRightRounded';
import { makeStyles } from '@material-ui/core/styles';

import { useCallback } from "react";
import Particles from "react-particles";
import { loadFull } from "tsparticles";

const useStyles = makeStyles({
    arrowButton: {
        overflow:"hidden",
        borderRadius:100,
        transition: 'background-color 0.25s ease',
        '&:active': {
            backgroundColor: 'rgba(255,255,255,0.5)',
        },
    },
});

export default function ProjectShowcase() {

    const [counter, setCounter] = useState(0);
    const [leave, setLeave] = useState(true);
    const classes = useStyles();
    const projectsList = {
        0: {
            title: "Planets In Trouble",
            desc: "A 2D Android Game made using the Unity Game Engine wherein the Player needs to keep the Planets from Colliding using only a Single Finger.",
            domain: "Android Game",
            image: require("../images/PIT.jpg"),
            linkRef: 'https://github.com/Innomer/PL-Game-APks',
        },
        1: {
            title: "Short-A-Thon",
            desc: "A Hackathon Hosting and Joining Website with ML Based Auto-Shortlisting features.",
            domain: "Web Devlopment (MERN)",
            image: require("../images/ST.jpg"),
            linkRef: 'https://github.com/Chaitya0623/Hackniche_Console.io',
        },
        2: {
            title: "Work Connect",
            desc: "A Website that allows Clients to post their issues and Local Workers can provide Quotations directly to the Clients.",
            domain: "Web Devlopment (MERN)",
            image: require("../images/WC.jpg"),
            linkRef: 'https://github.com/Innomer/Console.IO_WebDevelopment_Rookies',
        },
        3: {
            title: "Hand Volume Controller",
            desc: "A Python Program that allows us to change volume of device using Finger Gestures.",
            domain: "AI/ML",
            image: require("../images/HVC.jpg"),
            linkRef: 'https://github.com/Innomer/Self-Projects/tree/main/Volume%20Controller%20with%20Fingers',
        },
        4: {
            title: "Student, Teacher and Admin Chat Application",
            desc: "A Java Application that allows students and teachers to chat in a common group.",
            domain: "Java App Development",
            image: require("../images/ChatApp.jpg"),
            linkRef: 'https://github.com/Innomer/JavaMiniProject',
        }
    }


    useEffect(() => {
        projectsList[counter].leave = true;
    }, [counter]);

    const increaseCounter = (e) => {
        e.preventDefault();
        if (counter < Object.keys(projectsList).length - 1) {
            setTimeout(() => setCounter(counter + 1), 1000);
        }
        else {
            setTimeout(() => setCounter(0), 1000);
        }
        setLeave(false);
        setTimeout(() => setLeave(true), 2000);
    }
    const decreaseCounter = (e) => {
        e.preventDefault();
        if (counter > 0) {
            setTimeout(() => setCounter(counter - 1), 1000);
        }
        else {
            setTimeout(() => setCounter(Object.keys(projectsList).length - 1), 1000);
        }
        setLeave(false);
        setTimeout(() => setLeave(true), 2000);
    }

    const particlesInit = useCallback(async engine => {
        // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
        // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
        // starting from v2 you can add only the features you need reducing the bundle size
        await loadFull(engine);
    }, []);

    const particlesLoaded = useCallback(async container => {
        await console.log(container);
    }, []);

    return (
        <Box className="no-overflow" bgcolor="#000000" maxHeight="100vh" minHeight="75vh" sx={{ width: '100%', display: { sx: "block", lg: "flex" }, flexDirection: "column", justifyContent: "center", alignItems: "center", p: "5rem", textAlign: "center" }}>
            <Particles
                id="tsparticles"
                init={particlesInit}
                loaded={particlesLoaded}
                style={{ position: "absolute", left: "10px", top: "10px" }}
                width="100vw"
                height="100vh"
                params={{
                    "autoPlay": true,
                    "defaultThemes": {},
                    "delay": 0,
                    "fullScreen": {
                        "enable": false,
                        "zIndex": -1
                    },
                    "detectRetina": true,
                    "duration": 0,
                    "fpsLimit": 60,
                    "interactivity": {
                        "detectsOn": "window",
                        "events": {
                            "onClick": {
                                "enable": false,
                                "mode": []
                            },
                            "onDiv": {
                                "selectors": [],
                                "enable": false,
                                "mode": [],
                                "type": "circle"
                            },
                            "onHover": {
                                "enable": true,
                                "mode": "grab",
                                "parallax": {
                                    "enable": false,
                                    "force": 2,
                                    "smooth": 10
                                }
                            },
                            "resize": {
                                "delay": 0.5,
                                "enable": true
                            }
                        },
                        "modes": {
                            "attract": {
                                "distance": 200,
                                "duration": 0.4,
                                "easing": "ease-out-quad",
                                "factor": 1,
                                "maxSpeed": 50,
                                "speed": 1
                            },
                            "bounce": {
                                "distance": 200
                            },
                            "bubble": {
                                "distance": 200,
                                "duration": 0.4,
                                "mix": false,
                                "divs": {
                                    "distance": 200,
                                    "duration": 0.4,
                                    "mix": false,
                                    "selectors": []
                                }
                            },
                            "connect": {
                                "distance": 80,
                                "links": {
                                    "opacity": 0.5
                                },
                                "radius": 60
                            },
                            "grab": {
                                "distance": 100,
                                "links": {
                                    "blink": false,
                                    "consent": false,
                                    "opacity": 1
                                }
                            },
                            "push": {
                                "default": true,
                                "groups": [],
                                "quantity": 4
                            },
                            "remove": {
                                "quantity": 2
                            },
                            "repulse": {
                                "distance": 200,
                                "duration": 0.4,
                                "factor": 100,
                                "speed": 1,
                                "maxSpeed": 50,
                                "easing": "ease-out-quad",
                                "divs": {
                                    "distance": 200,
                                    "duration": 0.4,
                                    "factor": 100,
                                    "speed": 1,
                                    "maxSpeed": 50,
                                    "easing": "ease-out-quad",
                                    "selectors": []
                                }
                            },
                            "slow": {
                                "factor": 3,
                                "radius": 200
                            },
                            "trail": {
                                "delay": 0.005,
                                "pauseOnStop": true,
                                "quantity": 5,
                                "particles": {
                                    "color": {
                                        "value": "#ff0000",
                                        "animation": {
                                            "enable": true,
                                            "speed": 400,
                                            "sync": true
                                        }
                                    },
                                    "collisions": {
                                        "enable": false,
                                        "bounce": {
                                            "horizontal": {
                                                "random": {}
                                            },
                                            "vertical": {
                                                "random": {}
                                            }
                                        },
                                        "overlap": {}
                                    },
                                    "links": {
                                        "enable": false,
                                        "shadow": {},
                                        "triangles": {}
                                    },
                                    "move": {
                                        "outModes": {
                                            "default": "destroy"
                                        },
                                        "speed": 1,
                                        "angle": {},
                                        "attract": {
                                            "rotate": {}
                                        },
                                        "distance": {},
                                        "gravity": {},
                                        "path": {
                                            "delay": {
                                                "random": {}
                                            }
                                        },
                                        "trail": {}
                                    },
                                    "size": {
                                        "value": 5,
                                        "animation": {
                                            "enable": true,
                                            "speed": 5,
                                            "minimumValue": 1,
                                            "sync": true,
                                            "startValue": "min",
                                            "destroy": "max"
                                        },
                                        "random": {}
                                    },
                                    "bounce": {
                                        "horizontal": {
                                            "random": {}
                                        },
                                        "vertical": {
                                            "random": {}
                                        }
                                    },
                                    "destroy": {
                                        "split": {
                                            "factor": {
                                                "random": {}
                                            },
                                            "rate": {
                                                "random": {}
                                            }
                                        }
                                    },
                                    "life": {
                                        "delay": {
                                            "random": {}
                                        },
                                        "duration": {
                                            "random": {}
                                        }
                                    },
                                    "number": {
                                        "density": {}
                                    },
                                    "opacity": {
                                        "animation": {},
                                        "random": {}
                                    },
                                    "roll": {
                                        "darken": {},
                                        "enlighten": {}
                                    },
                                    "rotate": {
                                        "animation": {}
                                    },
                                    "shadow": {
                                        "offset": {}
                                    },
                                    "shape": {},
                                    "stroke": {
                                        "color": {
                                            "value": "",
                                            "animation": {
                                                "count": 0,
                                                "enable": false,
                                                "offset": {
                                                    "max": 0,
                                                    "min": 0
                                                },
                                                "speed": 0,
                                                "decay": 0,
                                                "sync": false
                                            }
                                        }
                                    },
                                    "tilt": {
                                        "animation": {}
                                    },
                                    "twinkle": {
                                        "lines": {},
                                        "particles": {}
                                    },
                                    "wobble": {}
                                }
                            },
                            "light": {
                                "area": {
                                    "gradient": {
                                        "start": {
                                            "value": "#ffffff"
                                        },
                                        "stop": {
                                            "value": "#000000"
                                        }
                                    },
                                    "radius": 1000
                                },
                                "shadow": {
                                    "color": {
                                        "value": "#000000"
                                    },
                                    "length": 2000
                                }
                            }
                        }
                    },
                    "manualParticles": [],
                    "particles": {
                        "bounce": {
                            "horizontal": {
                                "random": {
                                    "enable": false,
                                    "minimumValue": 0.1
                                },
                                "value": 1
                            },
                            "vertical": {
                                "random": {
                                    "enable": false,
                                    "minimumValue": 0.1
                                },
                                "value": 1
                            }
                        },
                        "collisions": {
                            "absorb": {
                                "speed": 2
                            },
                            "bounce": {
                                "horizontal": {
                                    "random": {
                                        "enable": false,
                                        "minimumValue": 0.1
                                    },
                                    "value": 1
                                },
                                "vertical": {
                                    "random": {
                                        "enable": false,
                                        "minimumValue": 0.1
                                    },
                                    "value": 1
                                }
                            },
                            "enable": true,
                            "mode": "bounce",
                            "overlap": {
                                "enable": true,
                                "retries": 0
                            }
                        },
                        "color": {
                            "value": "#BF8D39",
                            "animation": {
                                "h": {
                                    "count": 0,
                                    "enable": false,
                                    "offset": 0,
                                    "speed": 50,
                                    "decay": 0,
                                    "sync": false
                                },
                                "s": {
                                    "count": 0,
                                    "enable": false,
                                    "offset": 0,
                                    "speed": 1,
                                    "decay": 0,
                                    "sync": true
                                },
                                "l": {
                                    "count": 0,
                                    "enable": false,
                                    "offset": 0,
                                    "speed": 1,
                                    "decay": 0,
                                    "sync": true
                                }
                            }
                        },
                        "groups": {},
                        "move": {
                            "angle": {
                                "offset": 0,
                                "value": 90
                            },
                            "attract": {
                                "distance": 200,
                                "enable": false,
                                "rotate": {
                                    "x": 3000,
                                    "y": 3000
                                }
                            },
                            "center": {
                                "x": 50,
                                "y": 50,
                                "mode": "percent",
                                "radius": 0
                            },
                            "decay": 0,
                            "distance": {},
                            "direction": "none",
                            "drift": 0,
                            "enable": true,
                            "gravity": {
                                "acceleration": 9.81,
                                "enable": false,
                                "inverse": false,
                                "maxSpeed": 50
                            },
                            "path": {
                                "clamp": true,
                                "delay": {
                                    "random": {
                                        "enable": false,
                                        "minimumValue": 0
                                    },
                                    "value": 0
                                },
                                "enable": false,
                                "options": {}
                            },
                            "outModes": {
                                "default": "out",
                                "bottom": "out",
                                "left": "out",
                                "right": "out",
                                "top": "out"
                            },
                            "random": false,
                            "size": false,
                            "speed": 2,
                            "spin": {
                                "acceleration": 0,
                                "enable": false
                            },
                            "straight": false,
                            "trail": {
                                "enable": false,
                                "length": 10,
                                "fill": {}
                            },
                            "vibrate": false,
                            "warp": false
                        },
                        "number": {
                            "density": {
                                "enable": true,
                                "width": 1920,
                                "height": 1080
                            },
                            "limit": 150,
                            "value": 100
                        },
                        "opacity": {
                            "random": {
                                "enable": true,
                                "minimumValue": 0.3
                            },
                            "value": {
                                "min": 0.3,
                                "max": 1
                            },
                            "animation": {
                                "count": 0,
                                "enable": true,
                                "speed": 0.5,
                                "decay": 0,
                                "sync": false,
                                "destroy": "none",
                                "startValue": "random",
                                "minimumValue": 0.3
                            }
                        },
                        "reduceDuplicates": false,
                        "shadow": {
                            "blur": 0,
                            "color": {
                                "value": "#000"
                            },
                            "enable": false,
                            "offset": {
                                "x": 0,
                                "y": 0
                            }
                        },
                        "shape": {
                            "options": {},
                            "type": "circle"
                        },
                        "size": {
                            "random": {
                                "enable": true,
                                "minimumValue": 1
                            },
                            "value": {
                                "min": 1,
                                "max": 4
                            },
                            "animation": {
                                "count": 0,
                                "enable": true,
                                "speed": 5,
                                "decay": 0,
                                "sync": false,
                                "destroy": "none",
                                "startValue": "random",
                                "minimumValue": 4
                            }
                        },
                        "stroke": {
                            "width": 0,
                            "color": {
                                "value": "",
                                "animation": {
                                    "h": {
                                        "count": 0,
                                        "enable": false,
                                        "offset": 0,
                                        "speed": 0,
                                        "decay": 0,
                                        "sync": false
                                    },
                                    "s": {
                                        "count": 0,
                                        "enable": false,
                                        "offset": 0,
                                        "speed": 1,
                                        "decay": 0,
                                        "sync": true
                                    },
                                    "l": {
                                        "count": 0,
                                        "enable": false,
                                        "offset": 0,
                                        "speed": 1,
                                        "decay": 0,
                                        "sync": true
                                    }
                                }
                            }
                        },
                        "zIndex": {
                            "random": {
                                "enable": false,
                                "minimumValue": 0
                            },
                            "value": 0,
                            "opacityRate": 1,
                            "sizeRate": 1,
                            "velocityRate": 1
                        },
                        "life": {
                            "count": 0,
                            "delay": {
                                "random": {
                                    "enable": false,
                                    "minimumValue": 0
                                },
                                "value": 0,
                                "sync": false
                            },
                            "duration": {
                                "random": {
                                    "enable": false,
                                    "minimumValue": 0.0001
                                },
                                "value": 0,
                                "sync": false
                            }
                        },
                        "rotate": {
                            "random": {
                                "enable": false,
                                "minimumValue": 0
                            },
                            "value": 0,
                            "animation": {
                                "enable": false,
                                "speed": 0,
                                "decay": 0,
                                "sync": false
                            },
                            "direction": "clockwise",
                            "path": false
                        },
                        "destroy": {
                            "bounds": {},
                            "mode": "none",
                            "split": {
                                "count": 1,
                                "factor": {
                                    "random": {
                                        "enable": false,
                                        "minimumValue": 0
                                    },
                                    "value": 3
                                },
                                "rate": {
                                    "random": {
                                        "enable": false,
                                        "minimumValue": 0
                                    },
                                    "value": {
                                        "min": 4,
                                        "max": 9
                                    }
                                },
                                "sizeOffset": true,
                                "particles": {}
                            }
                        },
                        "roll": {
                            "darken": {
                                "enable": false,
                                "value": 0
                            },
                            "enable": false,
                            "enlighten": {
                                "enable": false,
                                "value": 0
                            },
                            "mode": "vertical",
                            "speed": 25
                        },
                        "tilt": {
                            "random": {
                                "enable": false,
                                "minimumValue": 0
                            },
                            "value": 0,
                            "animation": {
                                "enable": false,
                                "speed": 0,
                                "decay": 0,
                                "sync": false
                            },
                            "direction": "clockwise",
                            "enable": false
                        },
                        "twinkle": {
                            "lines": {
                                "enable": false,
                                "frequency": 0.05,
                                "opacity": 1
                            },
                            "particles": {
                                "enable": false,
                                "frequency": 0.05,
                                "opacity": 1
                            }
                        },
                        "wobble": {
                            "distance": 5,
                            "enable": false,
                            "speed": {
                                "angle": 50,
                                "move": 10
                            }
                        },
                        "orbit": {
                            "animation": {
                                "count": 0,
                                "enable": false,
                                "speed": 1,
                                "decay": 0,
                                "sync": false
                            },
                            "enable": false,
                            "opacity": 1,
                            "rotation": {
                                "random": {
                                    "enable": false,
                                    "minimumValue": 0
                                },
                                "value": 45
                            },
                            "width": 1
                        },
                        "links": {
                            "blink": false,
                            "color": {
                                "value": "random"
                            },
                            "consent": false,
                            "distance": 100,
                            "enable": true,
                            "frequency": 1,
                            "opacity": 1,
                            "shadow": {
                                "blur": 5,
                                "color": {
                                    "value": "#000"
                                },
                                "enable": false
                            },
                            "triangles": {
                                "enable": false,
                                "frequency": 1
                            },
                            "width": 1,
                            "warp": false
                        },
                        "repulse": {
                            "random": {
                                "enable": false,
                                "minimumValue": 0
                            },
                            "value": 0,
                            "enabled": false,
                            "distance": 1,
                            "duration": 1,
                            "factor": 1,
                            "speed": 1
                        }
                    },
                    "pauseOnBlur": true,
                    "pauseOnOutsideViewport": true,
                    "responsive": [],
                    "smooth": false,
                    "style": {},
                    "themes": [],
                    "zLayers": 100,
                    "emitters": []
                }} />
            <Grid className="no-overflow" container spacing={2} sx={{ display: { sx: "block",md: "flex" ,lg: "flex" } }} direction="row" justifyContent="center" alignItems="center" bgcolor="black" maxHeight="100vh" minHeight="75vh" id="work" >
                {/* <Grid item sx={{ display: { xs: "none", lg: "none" }, mr: "auto", ml: "auto" }}>
                    <IconButton aria-label="arrow" className={classes.arrowButton} onClick={decreaseCounter} >
                        <ArrowBackIcon style={{ color: 'white' }} />
                    </IconButton>
                </Grid> */}
                <Grid item sx={{ display: { sx: "block",md: "flex" , lg: "flex" }, minHeight: { xs: "75vh", md: "75vh", lg: "75vh" }, minWidth: { xs: "50vw", md: "50vw",lg: "50vw" } }}>
                    <Project counter={counter} title={projectsList[counter].title} desc={projectsList[counter].desc} domain={projectsList[counter].domain} image={projectsList[counter].image} linkRef={projectsList[counter].linkRef} leave={leave} />
                </Grid>
                {/* <Grid item sx={{ display: { xs: "none", lg: "none" }, ml: "auto", mr: "auto" }}>
                    <IconButton aria-label="arrow" className={classes.arrowButton} onClick={increaseCounter}>
                        <ArrowForwardIcon style={{ color: 'white' }} />
                    </IconButton>
                </Grid> */}
            </Grid>
                <Grid className="no-overflow" item sx={{ display: { xs: "flex",md:"flex" ,lg: "flex" }, ml: "auto", mr: "auto", alignItems:"center",justifyContent:"center" }}>
                    <IconButton aria-label="arrow" className={classes.arrowButton} onClick={decreaseCounter}>
                        <ArrowBackIcon style={{ color: 'white' }} />
                    </IconButton>
                    <IconButton aria-label="arrow" className={classes.arrowButton} onClick={increaseCounter}>
                        <ArrowForwardIcon style={{ color: 'white' }} />
                    </IconButton>
                </Grid>
        </Box>
    );
}